

// import React, { useEffect, useState } from "react";
// import Header from "../Components/Header";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { BsWhatsapp, BsTelegram, BsLink45Deg } from "react-icons/bs";
// import { FaCopy, FaUsers, FaWallet } from "react-icons/fa";
// import { RiUserSharedLine, RiInformationLine, RiDoubleQuotesL } from "react-icons/ri";
// import CopyToClipboard from "react-copy-to-clipboard";
// import Rightcontainer from "../Components/Rightcontainer";

// // --- Advanced Theme Colors ---
// const COLORS = {
//     primaryGradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     secondaryGradient: "linear-gradient(135deg, #FF6B6B 0%, #ED213A 100%)",
//     successGradient: "linear-gradient(135deg, #43E97B 0%, #38F9D7 100%)",
//     accent: "#5D5FEF",
//     cardBg: "#ffffff",
//     bodyBg: "#F0F2F5",
//     border: "rgba(226, 232, 240, 0.8)",
//     textDark: "#2D3748",
//     textMuted: "#718096",
//     shadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
//     innerShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)"
// };

// const Refer = () => {
//     const [user, setUser] = useState();
//     const [referData, setReferData] = useState(0);

//     useEffect(() => {
//         Cashheader();
//     }, []);

//     const Cashheader = () => {
//         let access_token = localStorage.getItem("token");
//         const headers = { Authorization: `Bearer ${access_token}` };
//         axios
//             .get(`https://api.kakaking.in/me`, { headers })
//             .then((res) => {
//                 setUser(res.data);
//                 Allgames(res.data.referral_code);
//             })
//             .catch(() => { });
//     };

//     const Allgames = async (id) => {
//         const access_token = localStorage.getItem("token");
//         const headers = { Authorization: `Bearer ${access_token}` };
//         await axios
//             .get(`https://api.kakaking.in/referral/code/${id}`, { headers })
//             .then((res) => {
//                 setReferData(res.data);
//             });
//     };

//     if (!user) return null;

//     const referralText = `KAKAKING लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते है। दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 3% कमीशन दिया जाएगा. 100% भरोसेमंद प्लेटफार्म। 24 hours support https://kakaking.in/login?refer=${user.referral_code}.`;

//     const handleCopySuccess = (msg) => {
//         Swal.fire({
//             position: "center",
//             icon: "success",
//             title: msg,
//             showConfirmButton: false,
//             timer: 1200,
//             background: '#fff',
//             customClass: {
//                 popup: 'rounded-20'
//             }
//         });
//     };

//     return (
//         <>
//             <Header user={user} />
//             <div className="refer-container-main">
//                 <div className="container py-5">
//                     <div className="row g-4 justify-content-center">
//                         <div className="col-lg-7 col-md-12">
                            
//                             {/* --- STATS SECTION --- */}
//                             <div className="row g-3 mb-4">
//                                 <div className="col-6">
//                                     <div className="stat-card-premium">
//                                         <div className="stat-icon-box blue-grad">
//                                             <FaUsers />
//                                         </div>
//                                         <div>
//                                             <p className="stat-label">Total Referrals</p>
//                                             <h3 className="stat-number">{referData || 0}</h3>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-6">
//                                     <div className="stat-card-premium">
//                                         <div className="stat-icon-box green-grad">
//                                             <FaWallet />
//                                         </div>
//                                         <div>
//                                             <p className="stat-label">Total Earnings</p>
//                                             <h3 className="stat-number">₹{user?.referral_earning || 0}</h3>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* --- HERO REFERRAL CARD --- */}
//                             <div className="hero-card">
//                                 <div className="hero-content">
//                                     <div className="d-flex align-items-center gap-2 mb-3">
//                                         <span className="badge-refer">LIFETIME REWARDS</span>
//                                     </div>
//                                     <h2 className="hero-title">Invite Friends & <br/><span>Earn Together</span></h2>
//                                     <p className="hero-desc">You receive a <span className="highlight-text">3% Commission</span> every time your referred friend plays a game.</p>
                                    
//                                     <div className="referral-box-outer">
//                                         <p className="box-label">Your Unique Referral Code</p>
//                                         <div className="referral-box-inner">
//                                             <span className="refer-code-text">{user?.referral_code}</span>
//                                             <CopyToClipboard text={user?.referral_code} onCopy={() => handleCopySuccess("Code Copied!")}>
//                                                 <button className="refer-copy-btn">
//                                                     <FaCopy /> <span>COPY</span>
//                                                 </button>
//                                             </CopyToClipboard>
//                                         </div>
//                                     </div>

//                                     <div className="social-share-grid">
//                                         <a href={`whatsapp://send?text=${referralText}`} className="share-link wa">
//                                             <BsWhatsapp /> WhatsApp
//                                         </a>
//                                         <a href={`https://t.me/share/url?url=https://kakaking.in/login?refer=${user?.referral_code}&text=${encodeURIComponent(referralText)}`} className="share-link tg">
//                                             <BsTelegram /> Telegram
//                                         </a>
//                                         <CopyToClipboard text={referralText} onCopy={() => handleCopySuccess("Link Copied!")}>
//                                             <div className="share-link cp">
//                                                 <BsLink45Deg size={20}/> Copy Link
//                                             </div>
//                                         </CopyToClipboard>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* --- GUIDELINES --- */}
//                             <div className="info-glass-card">
//                                 <div className="d-flex align-items-center gap-2 mb-4">
//                                     <RiInformationLine size={24} color={COLORS.accent} />
//                                     <h5 className="m-0 fw-bold">Program Rules</h5>
//                                 </div>
//                                 <div className="rule-item">
//                                     <div className="rule-dot"></div>
//                                     <p>Your friend must use your referral code during registration.</p>
//                                 </div>
//                                 <div className="rule-item">
//                                     <div className="rule-dot"></div>
//                                     <p>Commission is credited instantly to your wallet after game completion.</p>
//                                 </div>
//                                 <div className="rule-item">
//                                     <div className="rule-dot"></div>
//                                     <p>There is no limit to how many friends you can invite.</p>
//                                 </div>
//                             </div>

//                         </div>

//                         {/* --- RIGHT CONTAINER --- */}
//                         <div className="col-lg-5 d-none d-lg-block">
//                             <div className="sticky-top" style={{ top: '100px' }}>
//                                 <Rightcontainer />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <style>{`
//                 @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

//                 .refer-container-main {
//                     background-color: ${COLORS.bodyBg};
//                     min-height: 100vh;
//                     font-family: 'Outfit', sans-serif;
//                     padding-top: 70px;
//                 }

//                 /* Stats Card */
//                 .stat-card-premium {
//                     background: ${COLORS.cardBg};
//                     padding: 20px;
//                     border-radius: 24px;
//                     display: flex;
//                     align-items: center;
//                     gap: 15px;
//                     border: 1px solid ${COLORS.border};
//                     box-shadow: ${COLORS.shadow};
//                     transition: transform 0.3s ease;
//                 }
//                 .stat-card-premium:hover { transform: translateY(-5px); }

//                 .stat-icon-box {
//                     width: 48px;
//                     height: 48px;
//                     border-radius: 10px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     font-size: 20px;
//                     color: white;
//                 }
//                 .blue-grad { background: ${COLORS.primaryGradient}; }
//                 .green-grad { background: ${COLORS.successGradient}; }

//                 .stat-label {
//                     font-size: 12px;
//                     font-weight: 600;
//                     color: ${COLORS.textMuted};
//                     margin-bottom: 2px;
//                     text-transform: uppercase;
//                     letter-spacing: 0.5px;
//                 }
//                 .stat-number {
//                     font-size: 22px;
//                     font-weight: 800;
//                     color: ${COLORS.textDark};
//                     margin: 0;
//                 }

//                 /* Hero Card */
//                 .hero-card {
//                     background: white;
//                     border-radius: 32px;
//                     padding: 40px;
//                     position: relative;
//                     overflow: hidden;
//                     border: 1px solid ${COLORS.border};
//                     box-shadow: ${COLORS.shadow};
//                     margin-bottom: 24px;
//                 }
//                 .hero-card::before {
//                     content: '';
//                     position: absolute;
//                     top: -50px;
//                     right: -50px;
//                     width: 150px;
//                     height: 150px;
//                     background: ${COLORS.primaryGradient};
//                     opacity: 0.05;
//                     border-radius: 50%;
//                 }

//                 .badge-refer {
//                     background: #E0E7FF;
//                     color: ${COLORS.accent};
//                     padding: 6px 14px;
//                     border-radius: 100px;
//                     font-size: 11px;
//                     font-weight: 800;
//                     letter-spacing: 1px;
//                 }

//                 .hero-title {
//                     font-weight: 800;
//                     font-size: 32px;
//                     color: ${COLORS.textDark};
//                     line-height: 1.2;
//                     margin-bottom: 15px;
//                 }
//                 .hero-title span { color: ${COLORS.accent}; }
                
//                 .hero-desc {
//                     color: ${COLORS.textMuted};
//                     font-size: 15px;
//                     max-width: 90%;
//                     margin-bottom: 30px;
//                 }
//                 .highlight-text {
//                     color: #EF4444;
//                     font-weight: 700;
//                 }

//                 /* Referral Box */
//                 .referral-box-outer {
//                     margin-bottom: 30px;
//                 }
//                 .box-label {
//                     font-size: 12px;
//                     font-weight: 700;
//                     color: ${COLORS.textMuted};
//                     margin-bottom: 10px;
//                 }
//                 .referral-box-inner {
//                     background: #F8FAFC;
//                     border: 2px dashed #CBD5E0;
//                     padding: 10px 10px 10px 25px;
//                     border-radius: 20px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: space-between;
//                 }
//                 .refer-code-text {
//                     font-size: 26px;
//                     font-weight: 800;
//                     letter-spacing: 4px;
//                     color: ${COLORS.textDark};
//                 }
//                 .refer-copy-btn {
//                     background: ${COLORS.textDark};
//                     color: white;
//                     border: none;
//                     padding: 12px 25px;
//                     border-radius: 15px;
//                     font-weight: 700;
//                     display: flex;
//                     align-items: center;
//                     gap: 8px;
//                     transition: all 0.2s;
//                 }
//                 .refer-copy-btn:active { transform: scale(0.95); }

//                 /* Social Share */
//                 .social-share-grid {
//                     display: grid;
//                     grid-template-columns: repeat(3, 1fr);
//                     gap: 12px;
//                 }
//                 .share-link {
//                     padding: 14px;
//                     border-radius: 18px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 8px;
//                     font-size: 13px;
//                     font-weight: 700;
//                     text-decoration: none;
//                     transition: all 0.2s;
//                     cursor: pointer;
//                 }
//                 .wa { background: #DCFCE7; color: #166534; }
//                 .tg { background: #E0F2FE; color: #075985; }
//                 .cp { background: #F1F5F9; color: #475569; }
//                 .share-link:hover { transform: translateY(-3px); filter: brightness(0.95); }

//                 /* Info Card */
//                 .info-glass-card {
//                     background: white;
//                     padding: 30px;
//                     border-radius: 28px;
//                     border: 1px solid ${COLORS.border};
//                     box-shadow: ${COLORS.shadow};
//                 }
//                 .rule-item {
//                     display: flex;
//                     align-items: flex-start;
//                     gap: 12px;
//                     margin-bottom: 15px;
//                 }
//                 .rule-dot {
//                     width: 8px;
//                     height: 8px;
//                     background: ${COLORS.accent};
//                     border-radius: 50%;
//                     margin-top: 7px;
//                     flex-shrink: 0;
//                 }
//                 .rule-item p {
//                     font-size: 14px;
//                     color: ${COLORS.textMuted};
//                     margin: 0;
//                     line-height: 1.5;
//                 }

//                 @media (max-width: 576px) {
//                     .hero-title { font-size: 26px; }
//                     .refer-code-text { font-size: 20px; }
//                     .social-share-grid { grid-template-columns: 1fr; }
//                     .hero-card { padding: 25px; }
//                 }
//             `}</style>
//         </>
//     );
// };

// export default Refer;


import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import axios from "axios";
import Swal from "sweetalert2";

import {
  BsWhatsapp,
  BsTelegram,
  BsLink45Deg,
} from "react-icons/bs";

import {
  FaCopy,
  FaUsers,
  FaWallet,
  FaArrowRight,
  FaCheckCircle,
} from "react-icons/fa";

import {
  RiInformationLine,
  RiUserSharedLine,
} from "react-icons/ri";

import CopyToClipboard from "react-copy-to-clipboard";
import Rightcontainer from "../Components/Rightcontainer";

// import "./Refer.css";


const Refer = () => {

  const [user, setUser] = useState();
  const [referData, setReferData] = useState(0);


  // =========================================
  // GET USER DATA
  // =========================================

  useEffect(() => {
    Cashheader();
  }, []);


  const Cashheader = () => {

    let access_token =
      localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .get(
        `https://api.kakaking.in/me`,
        { headers }
      )
      .then((res) => {

        setUser(res.data);

        Allgames(
          res.data.referral_code
        );

      })
      .catch(() => {});

  };


  // =========================================
  // REFERRAL DATA
  // =========================================

  const Allgames = async (id) => {

    const access_token =
      localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    await axios
      .get(
        `https://api.kakaking.in/referral/code/${id}`,
        { headers }
      )
      .then((res) => {

        setReferData(res.data);

      });

  };


  if (!user) return null;


  // =========================================
  // REFERRAL TEXT
  // =========================================

  const referralText =
    `KAKAKING लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते है। दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 3% कमीशन दिया जाएगा. 100% भरोसेमंद प्लेटफार्म। 24 hours support https://kakaking.in/login?refer=${user.referral_code}.`;


  // =========================================
  // COPY SUCCESS
  // =========================================

  const handleCopySuccess = (msg) => {

    Swal.fire({

      position: "center",

      icon: "success",

      title: msg,

      showConfirmButton: false,

      timer: 1200,

      background: "#ffffff",

      customClass: {
        popup: "refer-swal-popup",
      },

    });

  };


  return (
    <>

      {/* ======================================
          HEADER
      ====================================== */}

      <Header user={user} />


      {/* ======================================
          MAIN PAGE
      ====================================== */}

      <div className="refer-page">


        {/* ==================================
            3D BACKGROUND
        ================================== */}

        <div className="refer-bg-orb refer-orb-one"></div>

        <div className="refer-bg-orb refer-orb-two"></div>

        <div className="refer-bg-orb refer-orb-three"></div>

        <div className="refer-bg-grid"></div>


        {/* ==================================
            MAIN CONTENT
        ================================== */}

        <div className="refer-layout">


          {/* =================================
              LEFT CONTENT
          ================================= */}

          <main className="refer-main-content">


            {/* =================================
                PAGE INTRO
            ================================= */}

            <div className="refer-page-intro">

              <div className="refer-intro-icon">
                <RiUserSharedLine />
              </div>

              <div>

                <span className="refer-eyebrow">
                  REFERRAL PROGRAM
                </span>

                <h1>
                  Invite & Earn
                </h1>

                <p>
                  Share your code with friends and
                  earn rewards together.
                </p>

              </div>

            </div>


            {/* =================================
                STATS
            ================================= */}

            <div className="refer-stats-grid">


              {/* TOTAL REFERRALS */}

              <div className="refer-stat-card">

                <div className="stat-3d-icon referrals-icon">

                  <FaUsers />

                </div>

                <div className="refer-stat-content">

                  <span>
                    TOTAL REFERRALS
                  </span>

                  <strong>
                    {referData || 0}
                  </strong>

                  <small>
                    Friends joined
                  </small>

                </div>

                <div className="stat-bg-number">
                  01
                </div>

              </div>


              {/* TOTAL EARNINGS */}

              <div className="refer-stat-card earnings-stat">

                <div className="stat-3d-icon earnings-icon">

                  <FaWallet />

                </div>

                <div className="refer-stat-content">

                  <span>
                    TOTAL EARNINGS
                  </span>

                  <strong>
                    ₹{user?.referral_earning || 0}
                  </strong>

                  <small>
                    Lifetime commission
                  </small>

                </div>

                <div className="stat-bg-number">
                  02
                </div>

              </div>

            </div>


            {/* =================================
                HERO CARD
            ================================= */}

            <section className="referral-hero-card">


              {/* animated border */}

              <div className="referral-animated-border"></div>


              {/* decorative circles */}

              <div className="hero-decor-circle hero-circle-one"></div>

              <div className="hero-decor-circle hero-circle-two"></div>


              <div className="hero-inner">


                {/* badge */}

                <div className="refer-premium-badge">

                  <span className="badge-live-dot"></span>

                  LIFETIME REWARDS

                </div>


                {/* title */}

                <h2 className="refer-hero-title">

                  Invite Friends

                  <br />

                  <span>
                    Earn Together
                  </span>

                </h2>


                {/* description */}

                <p className="refer-hero-description">

                  Get

                  <strong>
                    3% Commission
                  </strong>

                  {" "}every time your referred
                  friend plays a game.

                </p>


                {/* =================================
                    REFERRAL CODE
                ================================= */}

                <div className="referral-code-section">

                  <div className="referral-code-label">

                    <span>
                      YOUR UNIQUE REFERRAL CODE
                    </span>

                    <div className="code-status">

                      <span></span>

                      ACTIVE

                    </div>

                  </div>


                  <div className="referral-code-box">


                    <div className="code-left">

                      <div className="code-mini-icon">

                        <RiUserSharedLine />

                      </div>

                      <span className="refer-code-text">
                        {user?.referral_code}
                      </span>

                    </div>


                    <CopyToClipboard
                      text={user?.referral_code}
                      onCopy={() =>
                        handleCopySuccess(
                          "Code Copied!"
                        )
                      }
                    >

                      <button className="refer-copy-btn">

                        <FaCopy />

                        <span>
                          COPY
                        </span>

                        <FaArrowRight className="copy-arrow" />

                      </button>

                    </CopyToClipboard>

                  </div>

                </div>


                {/* =================================
                    SHARE SECTION
                ================================= */}

                <div className="share-title">

                  <span>
                    SHARE YOUR INVITE
                  </span>

                  <div></div>

                </div>


                <div className="social-share-grid">


                  {/* WHATSAPP */}

                  <a
                    href={`whatsapp://send?text=${referralText}`}
                    className="share-card whatsapp-share"
                  >

                    <div className="share-card-icon">

                      <BsWhatsapp />

                    </div>

                    <div className="share-card-text">

                      <strong>
                        WhatsApp
                      </strong>

                      <span>
                        Share instantly
                      </span>

                    </div>

                    <FaArrowRight className="share-arrow" />

                  </a>


                  {/* TELEGRAM */}

                  <a
                    href={`https://t.me/share/url?url=https://kakaking.in/login?refer=${user?.referral_code}&text=${encodeURIComponent(referralText)}`}
                    className="share-card telegram-share"
                  >

                    <div className="share-card-icon">

                      <BsTelegram />

                    </div>

                    <div className="share-card-text">

                      <strong>
                        Telegram
                      </strong>

                      <span>
                        Send to friends
                      </span>

                    </div>

                    <FaArrowRight className="share-arrow" />

                  </a>


                  {/* COPY LINK */}

                  <CopyToClipboard
                    text={referralText}
                    onCopy={() =>
                      handleCopySuccess(
                        "Link Copied!"
                      )
                    }
                  >

                    <div className="share-card copy-share">

                      <div className="share-card-icon">

                        <BsLink45Deg />

                      </div>

                      <div className="share-card-text">

                        <strong>
                          Copy Link
                        </strong>

                        <span>
                          Share anywhere
                        </span>

                      </div>

                      <FaArrowRight className="share-arrow" />

                    </div>

                  </CopyToClipboard>


                </div>


                {/* =================================
                    COMMISSION INFO
                ================================= */}

                <div className="commission-strip">

                  <div className="commission-icon">

                    <FaCheckCircle />

                  </div>

                  <div>

                    <strong>
                      Earn 3% Lifetime Commission
                    </strong>

                    <span>
                      No limit on the number of friends
                      you can invite.
                    </span>

                  </div>

                </div>


              </div>

            </section>


            {/* =================================
                PROGRAM RULES
            ================================= */}

            <section className="refer-rules-card">


              <div className="rules-header">

                <div className="rules-icon">

                  <RiInformationLine />

                </div>

                <div>

                  <span>
                    IMPORTANT
                  </span>

                  <h3>
                    Program Rules
                  </h3>

                </div>

              </div>


              <div className="rules-list">


                <div className="rule-row">

                  <div className="rule-number">
                    01
                  </div>

                  <div className="rule-content">

                    <strong>
                      Use Referral Code
                    </strong>

                    <p>
                      Your friend must use your
                      referral code during registration.
                    </p>

                  </div>

                  <FaCheckCircle className="rule-check" />

                </div>


                <div className="rule-row">

                  <div className="rule-number">
                    02
                  </div>

                  <div className="rule-content">

                    <strong>
                      Instant Commission
                    </strong>

                    <p>
                      Commission is credited instantly
                      to your wallet after game completion.
                    </p>

                  </div>

                  <FaCheckCircle className="rule-check" />

                </div>


                <div className="rule-row">

                  <div className="rule-number">
                    03
                  </div>

                  <div className="rule-content">

                    <strong>
                      Unlimited Invitations
                    </strong>

                    <p>
                      There is no limit to how many
                      friends you can invite.
                    </p>

                  </div>

                  <FaCheckCircle className="rule-check" />

                </div>


              </div>

            </section>


          </main>


          {/* =================================
              RIGHT CONTAINER
          ================================= */}

          <aside className="refer-right-container">

            <div className="refer-right-sticky">

              <Rightcontainer />

            </div>

          </aside>


        </div>

      </div>

    </>
  );
};


export default Refer;